import { SECTION_TYPES } from "@/lib/constants/sections";
import { Star } from "lucide-react";

const featuredTestimonialSection = {
  type: SECTION_TYPES.FEATURED_TESTIMONIAL,
  editingDisabled: true,
  content: {
    variantNumber: 0,
  },
  meta: {
    displayName: "Featured Testimonial",
    displayDescription: "A randomly-picked favorite testimonial for display.",
    displayIcon: Star,
    variantsCount: 2,
  },
};

export default featuredTestimonialSection;
